import { useState } from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import Countdown from "react-countdown";
import ImmersionModal from '../../../../atoms/modals/commonModal';
import { useSelector, useDispatch } from 'react-redux';
import UtilService from '../../../../../helper/service';
import {liveExperience, updateSettings} from "../../../../../store/actions/creator/analysis";
import {apiClient} from "../../../../../config/apiClient";
import CustomSnackBar from "../participantsDashboard/component/CustomSnackBar";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '80%',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column'
    }
  },
  playBtn: {
    height: 37,
    borderRadius: 6,
    background: '#199F4D',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#409F63',
    },
    margin: '0 21px',
  },
  title: {
      color: '#606B76',
      fontFamily: 'roboto-bold',
      fontSize: 20,
      '@media screen and (max-width: 600px)': {
        fontSize: 16
      }
  },
  description: {
    color: '#606B76',
    fontFamily: 'Spartan-regular',
    fontSize: 25,
    marginTop: 50
  },
  time: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 13,
    width: 414,
    height: 69,
    background: '#8192A2',
    marginBottom: 30,
    marginTop: -15,
    '& span': {
        paddingTop: 4,
        color: '#FFFFFF',
        fontFamily: 'Spartan-bold',
        fontSize: 45,
        width: 224
    },
    '@media screen and (max-width: 600px)': {
      width: 300,
      height: 50,
      '& span': {
        width: 160,
        fontSize: 30,
    },
    }
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center', 
  }
}));

function UpcomingSection(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { startTime } = props;
  const [open, setOpen] = useState(false);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const { currentSession } = useSelector((state: any) => state.analysis);
  const { session_type, session_code } = currentSession;
  const [showSnackAlert, setShowSnackAlert] = useState(false);
  const [checking, setChecking] = useState(false);

  const handleApply = () => {
    dispatch(updateSettings('mqttStatus', 'LIVE'))
    setOpen(false);
    dispatch(liveExperience(apolloClient.client, {
      user_id: loginUserData.user_id,
      session_id: currentSession.session_id
    }, () => {}));
  };

  const handleStart = async () => {
    if (session_type === 'ASYNC') {
      setChecking(true);
      const isReady = await isVideoReady();
      setChecking(false);
      if (isReady) {
        setOpen(true);
      } else {
        setShowSnackAlert(true);
      }
    } else {
      setOpen(true);
    }
  };

  const isVideoReady = async () => {
    const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${session_code}`);
    if (res.data) {
      const status = res.data[0]['stimulus_status'];
      return status === 'READY';
    }
    return false;
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <img src={'/assets/icons/liveanalysis/calendar_icon.svg'} alt={'img'} />
        <Box ml={4} style={{ width: 164}}>
          <p className={classes.title}>Scheduled Start:</p> 
          <p className={classes.title}>
            {UtilService.getOverviewExperienceDateFormatString(String(Number(currentSession.scheduled_start_at)))}
          </p>
        </Box>
      </div>
      <div className={classes.center}>
        <p className={classes.description}>STARTS AUTOMATICALLY IN</p>
        <div className={classes.time}>
          <span><Countdown date={parseInt(startTime) * 1000} /></span>
        </div>
        <Button className={classes.playBtn} style={{ color: '#fff' }} onClick={handleStart} disabled={checking}>
          <img src={'/assets/icons/liveanalysis/play.svg'} alt={'img'} />
          <span style={{ marginLeft: 5, marginRight: 5 }}>Start Now</span>
          { checking && <CircularProgress color="inherit" size={20}/> }
        </Button>
      </div>

      <ImmersionModal
        title={'Are you sure?'}
        description={'Starting now will override your original start time and begin collecting data from your Participants now. After you start, clicking STOP, will complete the measurement. You cannot restart. Only do this if you are absolutely sure you want to start now instead of at the original time.'}
        titleOK={'Yes, Start Collecting Data Now'}
        open={open}
        onApply={handleApply}
        onClose={() => setOpen(false)}
      />
      <CustomSnackBar type={'warning'} message={'Video is not ready yet.'} open={showSnackAlert} onClose={() => setShowSnackAlert(false)} />
    </div>
  );
}

export default UpcomingSection;